import localforage from 'localforage';
import { autorun, makeAutoObservable, toJS } from 'mobx';

import { AbsenceCalendarEntry, BlockTime, RecurrenceType } from 'src/types';

export interface BlockTimeObject {
  absences: AbsenceCalendarEntry[];
  recurring: BlockTime[];
  single: BlockTime[];
}

const emptyBlockTimes = (): BlockTimeObject => ({
  absences: [],
  recurring: [],
  single: [],
});

export class BlockTimesStateStore {
  blockTimes: BlockTimeObject = emptyBlockTimes();
  initialized: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  reset() {
    this.blockTimes = emptyBlockTimes();
    this.initialized = false;
  }

  get not_recurring() {
    return this.blockTimes.single.filter(
      (blockTime) => blockTime.recurrenceType === RecurrenceType.ONCE,
    );
  }
}

export interface BlockTimesStateProps {
  blockTimes: BlockTimeObject;
  initialized: boolean;
}

const BlockTimesState = new BlockTimesStateStore();

autorun(() => {
  // ! Note: 'initialized' is set to 'false' after hot module reload in development environment.
  if (!BlockTimesState.initialized) {
    return;
  }

  // Converts the observable-object to a javascript-object as mobx-observables can not be stored.
  const blockTimesState = toJS(BlockTimesState);

  localforage
    .setItem('blockTimesState', blockTimesState)
    .catch((error: any) => console.warn('could not be stored locally ', error));
});

export default BlockTimesState;
